import Radio from 'components/Form/Radio';
import {FC} from 'react';
import {useFormContext} from 'react-hook-form';
import {c, t} from 'ttag';

import useTaxTypeReadOnly from '../hooks';
import {ModalFormField} from '../utils';

type Props = Record<string, never>;

const RadioTaxInclusivity: FC<Props> = () => {
    const form = useFormContext<ModalFormField>();
    const readOnly = useTaxTypeReadOnly(form);

    return (
        <Radio
            label={c('tax').t`Unit Price...`}
            name="isTaxInclusiveRadio"
            options={[
                {
                    label: c('tax').t`excludes tax`,
                    value: 'false',
                },
                {
                    label: c('tax').t`includes tax`,
                    value: 'true',
                },
            ]}
            readOnly={readOnly}
            requiredType="hidden"
            rules={{
                validate: (value: ModalFormField['isTaxInclusiveRadio']) => {
                    if (!value && !readOnly) {
                        return t`Select Exclusive or Inclusive.`;
                    }

                    form.trigger('checkDuplicate');

                    return undefined;
                },
            }}
        />
    );
};

export default RadioTaxInclusivity;
